import React, { useContext, useState, useMemo } from "react";
import ReactECharts from "echarts-for-react";
import { ServicesContext } from "../../context/ServicesDataProvider";

const JCServiceAnalysis = () => {
  const {
    jcServiceAnalysisData = [],
    jcServiceAnalysisBs6Data = [],
    jcServiceAnalysis_non_bs6Data = [],
  } = useContext(ServicesContext);

  const [selectedCategory, setSelectedCategory] = useState("All");

  const selectedData = useMemo(() => {
    if (selectedCategory === "BS6") return jcServiceAnalysisBs6Data;
    if (selectedCategory === "Non-BS6") return jcServiceAnalysis_non_bs6Data;
    return jcServiceAnalysisData;
  }, [
    selectedCategory,
    jcServiceAnalysisData,
    jcServiceAnalysisBs6Data,
    jcServiceAnalysis_non_bs6Data,
  ]);

  const categories = useMemo(
    () => selectedData.map((item) => item.key),
    [selectedData]
  );

  const values = useMemo(
    () => selectedData.map((item) => item.doc_count),
    [selectedData]
  );

  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: function (params) {
        const data = params[0];
        return `${data.name}<br />Count: ${data.value}`;
      },
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '15%',
      top: '10%',
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: categories,
      axisLabel: {
        rotate: 60,
        fontSize: 9,
        interval: 0,
      },
    },
    yAxis: {
      type: "value",
      name: "Count",
    },
    series: [
      {
        data: values,
        type: "bar",
        barWidth: 25,
        barCategoryGap: '40%',
        itemStyle: {
          color: "#5F9ADE",
          borderRadius: [6, 6, 0, 0],
        },
        label: {
          show: true,
          position: "top",
          fontSize: 9,
          color: "#000",
        },
      },
    ],
  };

  return (
    <div className="flex flex-col items-center">
      <div
        className="sm:chart-container w-full"
        style={{
          maxWidth: "100%",
          height: "310px",
          overflowX: "auto",
        }}
      >
        <div className="bg-[#2374BF] mb-8 text-white pr-1  rounded-t-lg flex justify-between items-center w-full">
          <h2 className="text-md pl-2 p-1 font-semibold">JC Service Analysis</h2>
          <div className="relative">
            <select
              className="block appearance-none bg-[#FFFFFF66] border border-gray-300 py-1 px-4 pr-2 rounded leading-tight focus:outline-none focus:border-gray-300 text-sm text-white"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              <option className="text-black">All</option>
              <option className="text-black">BS6</option>
              <option className="text-black">Non-BS6</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center text-white">
              <svg
                className="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </div>
          </div>
        </div>

        <div style={{ overflowX: "auto", width: "100%" }}>
          <ReactECharts
            option={option}
            style={{
              height: "270px",
              width: `900px`,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default JCServiceAnalysis;